import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './style.css';

// Client-side credentials (development only)
const ADMIN_USER = 'admin';
const ADMIN_PASS = 'admin123';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // Simulate a small delay for UX
        setTimeout(() => {
            if (username === ADMIN_USER && password === ADMIN_PASS) {
                sessionStorage.setItem('adminLoggedIn', 'true');
                history.push('/admin/tours');
            } else {
                setError('Invalid username or password');
                setLoading(false);
            }
        }, 400);
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-backdrop" />
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <div className="admin-login-icon">🔧</div>
                    <h1>Admin Panel</h1>
                    <p>Hotspot Editor Login</p>
                </div>

                <form onSubmit={handleSubmit} className="admin-login-form">
                    {error && <div className="admin-login-error">{error}</div>}

                    <div className="admin-login-field">
                        <label htmlFor="admin-username">Username</label>
                        <input
                            id="admin-username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                            autoComplete="username"
                            required
                        />
                    </div>

                    <div className="admin-login-field">
                        <label htmlFor="admin-password">Password</label>
                        <input
                            id="admin-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                            autoComplete="current-password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="admin-login-btn"
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>

                <div className="admin-login-footer">
                    <a href="/index">← Back to Tour</a>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
